import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";

import Navbar from "../components/Navbars/Navbar";
import { ToastContainer } from "react-toastify";
import ConfirmPayment from "../views/View/ConfirmPayment";
import { fetchLoggedUser } from "../utils/UserHelper";

const View = () => {
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        fetchLoggedUser(setCurrentUser);
        return () => {};
    }, []);

    if (!currentUser) return <></>;
    return (
        <>
            <Navbar currentUser={currentUser} />

            {/* Main Content */}
            <main
                className="main-content-full-view"
                id="main-content-full-view"
            >
                <Route
                    path="/view/payments/confirm/:sessionId"
                    component={() => (
                        <ConfirmPayment currentUser={currentUser} />
                    )}
                />
            </main>
            <ToastContainer limit={3} />
        </>
    );
};

export default View;
